import styled from '@emotion/styled'
import type { FC } from 'react'
import { Fragment } from 'react'

import keyFindings from './data'
import KeyFindingSection from './KeyFindingSection'

const KeyFindings: FC = () => {
  return (
    <Wrapper>
      {keyFindings.map((keyFinding, index) => (
        <Fragment key={index}>
          <KeyFindingSection key={index} keyFinding={keyFinding} isLast={index === keyFindings.length - 1} />
        </Fragment>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default KeyFindings
